import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#06F",
  d: "M7.9.223a2.818 2.818 0 0 1 2.199 0l6.295 2.683C17.37 3.322 18 4.25 18 5.276v4.066c0 5.058-3.47 9.05-8.245 10.544a2.557 2.557 0 0 1-1.51 0C3.47 18.391 0 14.401 0 9.342V5.276c0-1.026.63-1.954 1.606-2.37L7.9.223Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M10.602 11.058c0 .547-.14.973-.421 1.277-.281.305-.672.457-1.172.457-.33 0-.616-.067-.86-.2a1.268 1.268 0 0 1-.55-.595c-.122-.261-.182-.574-.182-.94V6.002H5v5.111c0 .767.17 1.442.512 2.027.342.584.815 1.04 1.42 1.369.603.329 1.296.493 2.077.493.781 0 1.474-.162 2.078-.484a3.483 3.483 0 0 0 1.41-1.36c.335-.585.503-1.266.503-2.045V6.001h-2.398v5.057Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "shield-usimsacare"}) } }